/**
 * Hamburger Menu - Right Sidebar Navigation
 * Pure CSS animation via aria-expanded attribute (CodePen implementation)
 */
(function() {
  'use strict';

  const toggle = document.querySelector('[data-hamburger-toggle]');
  const menu = document.querySelector('[data-hamburger-menu]');

  if (!toggle || !menu) return;

  // Desktop color from data attribute (used on 1024px+), mobile always white
  const desktopColor = toggle.dataset.desktopColor || '#ffffff';

  // Apply correct initial color based on viewport
  function applyResponsiveColor() {
    if (window.innerWidth >= 1024) {
      toggle.style.setProperty('--color', desktopColor);
    } else {
      toggle.style.setProperty('--color', '#ffffff');
    }
  }

  // Set initial color
  applyResponsiveColor();

  // Update color on resize
  window.addEventListener('resize', function() {
    if (!isExpanded) {
      applyResponsiveColor();
    }
  });

  // Create body overlay element
  const overlay = document.createElement('div');
  overlay.className = 'menu-overlay fixed inset-0 bg-black/50 z-30 opacity-0 pointer-events-none transition-opacity duration-300';
  document.body.appendChild(overlay);

  let isExpanded = toggle.getAttribute('aria-expanded') === 'true';

  function openMenu() {
    toggle.setAttribute('aria-expanded', 'true');
    menu.classList.remove('translate-x-full');
    menu.setAttribute('aria-hidden', 'false');
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    overlay.classList.add('opacity-100', 'pointer-events-auto');
    document.body.classList.add('overflow-hidden');
    // On desktop (1024px+), use white for the X icon against dark overlay
    if (window.innerWidth >= 1024) {
      toggle.style.setProperty('--color', '#ffffff');
    }
    isExpanded = true;

    const firstLink = menu.querySelector('a');
    if (firstLink) {
      setTimeout(() => firstLink.focus(), 300);
    }
  }

  function closeMenu() {
    toggle.setAttribute('aria-expanded', 'false');
    menu.classList.add('translate-x-full');
    menu.setAttribute('aria-hidden', 'true');
    overlay.classList.add('opacity-0', 'pointer-events-none');
    overlay.classList.remove('opacity-100', 'pointer-events-auto');
    document.body.classList.remove('overflow-hidden');
    // Restore appropriate color based on viewport
    applyResponsiveColor();
    isExpanded = false;
    toggle.focus();
  }

  function toggleMenu() {
    isExpanded ? closeMenu() : openMenu();
  }

  function handleOutsideClick(event) {
    if (!isExpanded) return;
    if (toggle.contains(event.target)) return;
    if (menu.contains(event.target)) return;
    closeMenu();
  }

  toggle.addEventListener('click', function(e) {
    e.preventDefault();
    toggleMenu();
  });

  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isExpanded) {
      closeMenu();
    }
  });

  document.addEventListener('click', handleOutsideClick);

  menu.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', function() {
      setTimeout(closeMenu, 100);
    });
  });
})();
